import Service from '@/service/index.js';
// import RegExpObj from '@/utils/regExp.js';
// import { errorMessage } from '@/utils/message.js';
import SelectBank from '@/components/select-bank/index.vue';
import Bus from '../../../../transaction-pro/bus.js';
import { mapGetters } from 'vuex';
const ruleForm = function() {
  return {
    payType: '',
    payDay: '',
    circulationType: '',
    circulationTypeCode: '',
    bondRatio: null,
    isSublet: null, // 是否可以转租
    leaseDeposit: '', // 承租押金
    installmentDesc: '',
    sumPrice: '', // 交易价格
    contractorPriorityCode: ['2'], // 优先购买权人
    installments: [
      {
        payTime: '',
        payAmount: null,
        key: Math.random()
      },
      {
        payTime: '',
        payAmount: null,
        key: Math.random()
      }
    ],
    originalContractor: '',
    certificateNo: '',
    bankId: ''
  };
};

export default {
  components: {
    SelectBank
  },
  props: ['projectInfo', 'landTotalForm'],
  data() {
    const isSubletAff =  (rule, value, callback) => {
      if (value === null) {
        callback(new Error('请选择是否可以转租'));
      } else {
        callback();
      }
    };
    const leaseDepositRatio =  (rule, value, callback) => {
      console.log(value, 'value');
      if (value === '') {
        callback(new Error('请输入承租押金'));
      } else {
        callback();
      }
    };
    // const validateCirculationTypeCode = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error('请选择流转方式'));
    //   } else if ((value === '4') && !this.ruleForm.circulationType) {
    //     callback(new Error('请输入流转方式!'));
    //   } else {
    //     callback();
    //   }
    // };
    const validatePayType = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择付款方式'));
      } else if (this.projectType === '1' && this.projectSubType === '2' && (value === '1') && !this.ruleForm.payDay) {
        callback(new Error('请输入'));
      } else if ((value === '1') && !this.ruleForm.payDay) {
        callback(new Error('请输入'));
      } else {
        callback();
      }
    };
    const validateBondRatio = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入保证金比例'));
      } else if ((value < 10) || (value > 50) || !/^[0-9]*$/.test(value)) {
        callback(new Error('请输入10-50正整数保证金比例!'));
      } else {
        callback();
      }
    };
    const validateCertificateNo = (rule, value, callback) => {
      if (value && value.length < 18) {
        callback(new Error('请输入正确的统一社会信用代码或身份证号'));
      } else {
        callback();
      }
    };
    return {
      deliveryPeriod: '',
      transferType: '',
      dataShow: true,
      projectType: 1,
      projectSubType: 1,
      transferTypeArr: [],
      payTypeArr: [],
      contractorPriorityCodeArr: [],
      circulationTypeCodeArr: [],
      // date: [],
      repriedDataText: '发包期限',
      noticeText: '自公告之日起10个工作日',
      sumMarginText: '竞价保证金总金额',
      payTypeArrNH: [
        {
          code: '1',
          sort: 1,
          value: '一次性付款'
        }
      ],
      contractorPriorityCodeArrNH: [
        {
          code: '2',
          sort: 2,
          value: '本集体经济组织成员'
        },
        {
          code: '4',
          sort: 4,
          value: '其他'
        }
      ],
      ruleForm: ruleForm(),
      rules: {
        payType: [
          { required: true, validator: validatePayType, trigger: 'change' }
        ],
        isSublet: [
          {required: true, validator: isSubletAff,  trigger: 'change' }
        ],
        bondRatio: [
          { required: true, validator: validateBondRatio, trigger: 'blur' }
        ],
        leaseDeposit: [
          { type: 'string', required: true, validator: leaseDepositRatio, trigger: 'change' }
        ],
        certificateNo: [
          { required: false, validator: validateCertificateNo, trigger: 'blur' }
        ],
        sumPrice: [
          { required: true, message: '请输入交易价格', trigger: 'blur' }
        ],
        bankId: [
          { required: true, message: '请选择银行账号', trigger: 'blur' }
        ]
      },

      // payTimeRules: {
      //   required: true, message: '请选择付款日期', trigger: 'blur'
      // },
      // payAmountRules: [
      //   {required: true, message: '请输入付款比例', trigger: 'blur'},
      //   {pattern: RegExpObj.num, message: '请输入正确的付款比例', trigger: 'blur' }
      // ],
      subletArr: [
        {code: false, value: '否'},
        {code: true, value: '是'}
      ],
      qualifications: [
        {code: 1, value: '资格后审'}
      ],
      qualiy: 1
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'tradeType'
    ]),
    // 保证金总额
    sumMargin: {
      get: function() {
        // 1整体 2拆分
        // console.log(this.transferType, this.transferType === '1', 'this.transferType');
        if (this.transferType === '1') {
          // 房屋建筑物 计算公式 每年（期）租金总金额*出租期限*交纳保证金比例
          // if(this.projectType && Number(this.projectType) === 6) {
          //   if (this.landTotalForm.sumPrice && this.ruleForm.bondRatio && this.deliveryPeriod) {
          //     const num = this.landTotalForm.sumPrice * Number(this.deliveryPeriod) * (this.ruleForm.bondRatio / 100);
          //     console.log('年限', this.deliveryPeriod);
          //     console.log('金额', this.landTotalForm.sumPrice);
          //     console.log('比例', this.ruleForm.bondRatio);
          //     if (num >= 100) {
          //       const arr = num.toString().split('.');
          //       const text = Math.round(arr[0] / 100) * 100;
          //       return text;
          //     } else {
          //       const text = num.toFixed(2);
          //       return text;
          //     }
          //   } else {
          //     return '';
          //   }
          // } else {
          // 综合类
          if(Number(this.projectType) === 8) {
            this.landTotalForm.sumPrice = this.ruleForm.sumPrice;
          } else {
            this.ruleForm.sumPrice = this.landTotalForm.sumPrice;
          }
          if (this.landTotalForm.sumPrice && this.ruleForm.bondRatio) {
            const num = this.landTotalForm.sumPrice * (this.ruleForm.bondRatio / 100);
            if (num >= 100) {
              // console.log(num);
              const arr = num.toString().split('.');
              const text = Math.round(arr[0] / 100) * 100;
              return text;
            } else {
              // const text = num.toFixed(2);
              // const text = Math.round(num);
              // return text;
              return 100;
            }
          } else {
            return '';
          }
          // }
        } else if (this.transferType === '2') {
          if (this.landTotalForm.sumPrice && this.landTotalForm.count && this.ruleForm.bondRatio) {
            const num = this.landTotalForm.sumPrice * (this.ruleForm.bondRatio / 100) / this.landTotalForm.count;
            if (num >= 100) {
              const arr = num.toString().split('.');
              const text = Math.round(arr[0] / 100) * 100;
              return text;
            } else {
              // const text = num.toFixed(2);
              // return text;
              return 100; // 竞价保证金总额小于100 则等于100
            }
          } else {
            return '';
          }
        }
      }
    }
  },
  watch: {
    projectInfo: {
      handler: 'initFrom',
      immediate: true
    }
    // 转让方式的变化 改变公告时间的 文案
    // 'ruleForm.transferType': function() {
    //   if(this.transferType === '2') {
    //     // this.sumMarginText = '地块保证金金额';
    //     this.sumMarginText = '保证金总金额';
    //   } else {
    //     this.sumMarginText = '保证金总金额';
    //   }
    // }
  },
  created () {
    // 优先购买权人  用户类型为农村集体经济组织默认勾选1和3
    if (Number(this.userInfo.type) === 3) {
      this.ruleForm.contractorPriorityCode = ['1', '2', '3'];
    }
    // console.log(this.projectType, this.projectSubType);
    const arr = [
      ['transferTypeArr', 'TRANSFER_TYPE'], ['payTypeArr', 'PAY_TYPE'], ['contractorPriorityCodeArr', 'CONTRACTOR_PRIORITY'],
      ['circulationTypeCodeArr', 'CIRCULATION_TYPE']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          if (value[1] === 'CONTRACTOR_PRIORITY') {
            this[value[0]] = res.data.sort((a, b) => { return a.sort - b.sort; });
          } else {
            this[value[0]] = res.data;
          }
        }
      });
      // console.log(this.contractorPriorityCodeArr, 1);
    });
  },
  mounted() {
    // 年限
    Bus.$on('deliveryPeriod', (deliveryPeriod) => {
      this.deliveryPeriod = deliveryPeriod;
    });
    // 接受basic的参数
    Bus.$on('msg', (projectType, projectSubType, landCategory, transferType) => {
      this.projectType = projectType;
      this.projectSubType = projectSubType;
      if(Number(projectType) === 1 && Number(projectSubType) === 2) {
        this.ruleForm.payType = '1';
      }
      // 公告时间
      if((Number(this.projectType) === 6 && Number(this.projectSubType) === 1)
        || Number(this.projectType) === 7
        || (Number(this.projectType) === 2 && Number(this.projectSubType) === 3) ) {
        this.noticeText = '自公告之日起5个工作日';
      } else {
        this.noticeText = '自公告之日起10个工作日';
      }
      // 动态监听base-form内的 转让方式
      if (transferType) {
        this.transferType = String(transferType);
      }
      // 保证金名词修改
      if(this.transferType === '2') {
        if(Number(this.projectType) === 1 && (Number(this.projectSubType) === 1 || Number(this.projectSubType) === 2)) {
          this.sumMarginText = '地块保证金金额';
        } else {
          this.sumMarginText = '标的保证金金额';
        }
      }
      // 农机设备出租
      if(this.contractorPriorityCodeArr.length > 0 && ((Number(this.projectType) === 7 && Number(this.projectSubType) === 2) || Number(this.projectType) === 6)) {
        this.contractorPriorityCodeArr[0].value = '集体经济组织原承租人';
        this.contractorPriorityCodeArr[2].value = '外部原承租人';
      }
    });
  },
  methods: {
    // 初始化获取组件传参
    initFrom() {
      // this.ruleForm.contractorPriorityCode = ['2'];
      this.projectInfo && this.projectInfo.massifs && this.projectInfo.massifs.forEach(item => {
        Object.keys(item).forEach((key) => {
          item[key] = String(item[key]);
        });
      });
      this.massifs = this.projectInfo && this.projectInfo.massifs;
      Object.keys(this.ruleForm).forEach((key) => {

        if(key === 'contractorPriorityCode') {
          if (this.projectInfo.contractorPriorityCode) {
            this.ruleForm.contractorPriorityCode = this.projectInfo[key];
          }
        } else {
          this.ruleForm[key] = this.projectInfo[key];
        }

        if(key === 'isSublet') {
          this.ruleForm.isSublet = this.projectInfo.isSublet;
        } else if (this.projectInfo && this.projectInfo[key] && ((typeof this.projectInfo[key] === 'string') || (typeof this.projectInfo[key] === 'number') || (typeof this.projectInfo[key] === 'boolean'))) {
          this.ruleForm[key] = this.projectInfo && String(this.projectInfo[key]);
        } else if (key === 'installments') {
          if (this.projectInfo && this.projectInfo.installments) {
            this.projectInfo && this.projectInfo.installments.forEach(item => {
              Object.keys(item).forEach((key) => {
                item[key] = String(item[key]);

              });
            });
            this.ruleForm.installments = this.projectInfo && this.projectInfo.installments;
          } else {
            this.ruleForm.installments = [{payTime: '', payAmount: null, key: Math.random()}, {payTime: '', payAmount: null, key: Math.random()}];
          }
        }
      });
      if(this.projectInfo && this.projectInfo.projectType) {
        this.projectType  = this.projectInfo.projectType;
      }
      if(this.projectInfo && this.projectInfo.projectSubType) {
        this.projectSubType  = this.projectInfo.projectSubType;
      }

    },
    // 切换大类的时候清空 当前projectType与返回的一致时 则调用获取projectInfo的值的方法
    clear(){
      if(Number(this.projectType) === Number(this.projectInfo.projectType)) {
        this.initFrom();
        return false;
      };
      this.ruleForm = ruleForm();

      // 优先购买权人  用户类型为农村集体经济组织默认勾选1和3
      if (Number(this.userInfo.type) === 3) {
        this.ruleForm.contractorPriorityCode = ['1', '2', '3'];
      }
      // this.date = null;
      // this.$nextTick(() => {
      //   if(this.$refs['otherForm']) {
      //     this.$refs['otherForm'].resetFields();
      //   }
      // });
    },
    // 转让方法师生改变的时候
    agreeChange(e) {
      if(e === '1') {
        this.ruleForm.installmentDesc = '';
      } else {
        this.ruleForm.payDay = '';
      }
    },
    deleteInstallments (index) {
      this.ruleForm.installments.splice(index, 1);
    },
    addInstallments () {
      this.ruleForm.installments.push({
        payTime: '',
        payAmount: null,
        key: Math.random()
      });
    },
    test() {
      return new Promise((resolve, reject) => {
        this.$refs['otherForm'].validate((valid) => {
          if (valid) {
            // console.log('----other----');
            // if (this.ruleForm.payType === '2') {
            //   let num = 0;
            //   this.ruleForm.installments.forEach(item => num+= Number(item.payAmount));
            //   if (num === 100) {
            //     this.ruleForm.sumMargin = this.sumMargin;
            //     resolve(JSON.parse(JSON.stringify(this.ruleForm)));
            //   } else {
            //     errorMessage('分期付款比例之和必须为100');
            //     reject();
            //   }
            // } else {
            // this.ruleForm.sumMargin = this.sumMargin;

            let ruleForm = {
              ...this.ruleForm,
              sumMargin: this.sumMargin
              // contractorPriorityCode: JSON.stringify(this.ruleForm.contractorPriorityCode)
            };
            resolve(JSON.parse(JSON.stringify(ruleForm)));
            // }
          } else {
            reject();
          }
        });
      });
    }
  }
};
